import { ScoreSetState } from '../state';

export const clearScoreSetData = (state: ScoreSetState) => {
  state.scoreSet.data = undefined;
};
